import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Mail } from 'lucide-react';
import { useData } from '../context/DataContext';
import { BUSINESS_INFO } from '../config/business';

const Footer = () => {
  const { categories } = useData();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About LOJE</h3>
            <p>Your one-stop destination for fashion. Quality products, great prices, and excellent service.</p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                <Instagram size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                <Twitter size={20} />
              </a>
              <a href="mailto:info@loje.com">
                <Mail size={20} />
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul className="footer-links">
              <li key="home"><Link to="/">Home</Link></li>
              <li key="shop-all"><Link to="/shop-all">Shop All</Link></li>
              <li key="about"><Link to="/about">About Us</Link></li>
              <li key="contact"><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Categories</h3>
            <ul className="footer-links">
              {categories.map(category => (
                <li key={category.docId}>
                  <Link to={`/category/${category.id}`}>
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Info</h3>
            <ul className="footer-links">
              <li key="email">Email: {BUSINESS_INFO.email}</li>
              <li key="phone">Phone: {BUSINESS_INFO.phone}</li>
              <li key="address">{BUSINESS_INFO.address}</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 LOJE. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
